export default [
  {
    title: 'Co-Pay',
    resource: 'vector',
    action: 'read',
    subject: 'Opportunity',
    icon: { icon: 'ic:outline-card-travel' },
    children: [
      {
        title: 'Copay Dashboard',
        resource: 'vector',
        action: 'read',
        subject: 'Opportunity',
        to: { name: 'vector-home' },
      },
      {
        title: 'Cases',
        resource: 'vector',
        action: 'read',
        subject: 'Case',
        to: { name: 'vector-cases-home' },
      },
      {
        title: 'Opportunities',
        resource: 'vector',
        action: 'read',
        subject: 'Opportunity',
        to: { name: 'vector-opportunities-home' },
      },
      {
        title: 'Funders',
        resource: 'vector',
        action: 'read',
        subject: 'Funder',
        to: { name: 'vector-funders-home' },
      },
      {
        title: 'Programs',
        resource: 'vector',
        action: 'read',
        subject: 'Program',
        to: { name: 'vector-funders-programs-home' },
      },
      {
        title: 'Providers',
        resource: 'vector',
        action: 'read',
        subject: 'Provider',
        to: { name: 'vector-providers-home' },
      },
      {
        title: 'Patients',
        resource: 'vector',
        action: 'read',
        subject: 'Patient',
        to: { name: 'vector-patients-home' },
      },
      {
        title: 'Automation Dashboards',
        resource: 'vector',
        action: 'read',
        subject: 'AdminTools',
        to: { name: 'vector-admin-tools-automation-runs-home' },
      },
      {
        title: 'Configuration',
        resource: 'vector',
        action: 'read',
        subject: 'AdminTools',
        to: { name: 'vector-admin-tools-copay-configuration-home' },
      },
    ],
  },
  {
    title: 'SSDI',
    resource: 'vector',
    action: 'read',
    subject: 'SSDI',
    icon: { icon: 'ic:baseline-phone' },
    children: [
      {
        title: 'Call List',
        resource: 'vector',
        action: 'read',
        subject: 'SSDI',
        to: { name: 'vector-ssdi-call-list' },
      },
      {
        title: 'Partner Reconciliation',
        resource: 'vector',
        action: 'read',
        subject: 'SSDI',
        to: { name: 'vector-ssdi-reconciliation-import' },
      },
    ],
  },
  {
    title: 'Medicaid',
    resource: 'vector',
    action: 'read',
    subject: 'Case',
    icon: { icon: 'ic:outline-featured-play-list' },
    children: [
      {
        title: 'Applications',
        resource: 'vector',
        action: 'read',
        subject: 'Case',
        to: { name: 'vector-medicaid-applications' },
      },
      {
        title: 'PAM Assignments',
        resource: 'vector',
        action: 'read',
        subject: 'Case',
        to: { name: 'vector-medicaid-pam-assignments' },
      },
    ],
  },
  {
    title: 'Customer Ops',
    resource: 'vector',
    action: 'read',
    subject: 'AdminTools',
    icon: { icon: 'ic:baseline-people' },
    children: [
      {
        title: 'Customers',
        resource: 'vector',
        action: 'read',
        subject: 'AdminTools',
        to: { name: 'vector-admin-tools-customers-home' },
      },
      {
        title: 'Billing & Reporting',
        resource: 'vector',
        action: 'read',
        subject: 'AdminTools',
        to: { name: 'vector-admin-tools-reporting-home' },
      },
      {
        title: 'Outreach Scripts',
        resource: 'vector',
        action: 'read',
        subject: 'AdminTools',
        to: { name: 'vector-admin-tools-outreach-scripts-home' },
      },
    ],
  },
  {
    title: 'Insurance Verification',
    resource: 'vector',
    action: 'read',
    subject: 'VerificationSession',
    icon: { icon: 'mdi-shield-check-outline' },
    to: { name: 'vector-insurance-verification-home' },
  },
]
